import React from 'react';
import Datetime from 'react-datetime';
import 'flatpickr/dist/themes/material_green.css'
import { Col, Row, Form, Button, Accordion, Card, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faUndoAlt, faFileCsv, faFilePdf, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import 'react-bootstrap-multiselect/css/bootstrap-multiselect.css'
import moment from 'moment';
import './react-datetime.css';
import './Filter.css';

const Filter = (props) => {
  const {transactionNo, merchantRef, fromDate, toDate,
    txnStatusCode, payerAccount, merchantCustNo} = props.criteria;
  
  const {isDownloading} = props;

  return (
    <React.Fragment>
      {/* <Accordion defaultActiveKey="0">
      <Card className="border-0"> 
        <Card.Header>
          <Accordion.Toggle as={Button} variant="link" className="link" eventKey="0">
            Filter
          </Accordion.Toggle>
        </Card.Header>
        <Accordion.Collapse eventKey="0">
          <Card.Body> */}
            <Row>        
              <Col sm={2} className="pr-0">
                <Form.Group controlId="transactionNo">
                  <Form.Label className="text-grey font-weight-bold medium">Transaction No.</Form.Label>
                  <Form.Control type="text" name="transactionNo" value={transactionNo} onChange={props.onChange} placeholder="Transaction no." />
                </Form.Group>
              </Col>
              <Col sm={2} className="pr-0">
                <Form.Group controlId="merchantRef">
                  <Form.Label className="text-grey font-weight-bold medium">Merchant Reference No.</Form.Label>
                  <Form.Control type="text" name="merchantRef" value={merchantRef} onChange={props.onChange} placeholder="Merchant reference no." />
                </Form.Group>
              </Col>
              <Col sm={2} className="pr-0">
                <Form.Group controlId="transactionStatus">
                  <Form.Label className="text-grey font-weight-bold medium">Status</Form.Label>
                  <Form.Control as="select"
                    name="txnStatusCode"
                    value={txnStatusCode}
                    onChange={props.onChange}>
                    <option value="">All</option>
                    <option value='1000'>Payment Success</option>
                    <option value='0000'>Created</option>
                    <option value='1001'>Validation Failed</option>
                    <option value='1002'>Payment Failed</option>
                    <option value='1003'>Pending Processing</option>
                    <option value='1004'>Pending approval</option>
                    <option value='1005'>Cancelled</option>
                    <option value='9999'>Error</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col sm={2} className="pr-0">
                <Form.Group controlId="fromDate">
                  <Form.Label className="text-grey font-weight-bold medium">From</Form.Label>
                  <Datetime
                    onChange={(date) => {
                      const dateStr = moment.isMoment(date) ? date.format("YYYYMMDDHHmmss") : date;
                      props.onChange({ target: { name: 'fromDate', value: dateStr } })
                    }}
                    dateFormat="DD/MM/YYYY"
                    timeFormat="HH:mm"
                    value={moment(fromDate, "YYYYMMDDHHmmss", true).isValid() ? moment(fromDate, "YYYYMMDDHHmmss", true) : fromDate}
                  />
                </Form.Group>
              </Col>
              <Col sm={2} className="pr-0">
                <Form.Group controlId="toDate">
                  <Form.Label className="text-grey font-weight-bold medium">To</Form.Label>
                  <Datetime
                    onChange={(date) => {
                      const dateStr = moment.isMoment(date) ? date.format("YYYYMMDDHHmmss") : date;
                      props.onChange({ target: { name: 'toDate', value: dateStr } })
                    }}
                    dateFormat="DD/MM/YYYY"
                    timeFormat="HH:mm"
                    value={moment(toDate, "YYYYMMDDHHmmss", true).isValid() ? moment(toDate, "YYYYMMDDHHmmss", true) : toDate}
                  />
                </Form.Group>
              </Col> 
            </Row>
            <Row>
              <Col sm={2} className="pr-0">
                <Form.Group controlId="payerAccount">
                  <Form.Label className="text-grey font-weight-bold medium">Payer Account No.</Form.Label>
                  <Form.Control type="text" name="payerAccount" value={payerAccount} onChange={props.onChange} placeholder="Payer account" />
                </Form.Group>
              </Col>
              <Col sm={2} className="pr-0">
                <Form.Group controlId="merchantCustNo">
                  <Form.Label className="text-grey font-weight-bold medium">Merchant Customer No.</Form.Label>
                  <Form.Control type="text" name="merchantCustNo" value={merchantCustNo} onChange={props.onChange} placeholder="Customer no." />
                </Form.Group>
              </Col>
              <Col sm={2} className="pr-0" className="pr-0 pt-1 mt-4">
                <Button type="button" variant="link" className="link" onClick={props.onSubmit}>
                  <FontAwesomeIcon size="lg" icon={faSearch} />
                </Button>
                <Button type="button" variant="link" className="link" onClick={props.onReset}>
                  <FontAwesomeIcon size="lg" icon={faUndoAlt} />
                </Button>
                <Button disabled={isDownloading} type="button" variant="link" className="link" onClick={props.onExportCSV}>
                  <FontAwesomeIcon size="lg" icon={faFileCsv} />
                </Button>
                {/* <Button disabled={isDownloading} type="button" variant="link" className="link" onClick={props.onExportCSV}>
                  <FontAwesomeIcon size="lg" icon={faFilePdf} />
                </Button>
                <Button disabled={isDownloading} type="button" variant="link" className="link" onClick={props.onExportCSV}>
                  <FontAwesomeIcon size="lg" icon={faFileExcel} />
                </Button> */}
              </Col>
            </Row>
            {/* <Row>
              
            </Row> */}
          {/* </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion> */}
      
    </React.Fragment> 
  );
}
export default Filter;